import { useIntl } from '@finn/ui-utils';
import { useMemo } from 'react';

import { GenericVehicleDetails } from '../../core/types';
import { getEarliestDelivery } from '../../product-cards';

export const useDeliveryText = (
  vehicle?: GenericVehicleDetails,
  term?: number
) => {
  const intl = useIntl();

  return useMemo(() => {
    let available_from = vehicle?.available_from;
    let deviation_in_weeks = vehicle?.available_from_deviation_in_weeks;

    const availabilityByTerm = vehicle?.availability_by_term[String(term)];
    if (term && availabilityByTerm) {
      available_from = availabilityByTerm.available_from;
      deviation_in_weeks = availabilityByTerm.deviation_in_weeks;
    }

    const date = getEarliestDelivery({
      availableFrom: available_from ?? '',
      deviationInWeeks: deviation_in_weeks,
      intl,
    });

    return intl.formatMessage('pdp.deliverableFrom', { date });
  }, [vehicle, term, intl]);
};
